import React from 'react';
import Modal from '../../../components/common/Modal';

const ViewRole = ({ isOpen, onClose, data }) => {
  if (!data) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="View Role Details"
      size="md"
    >
      <div className="modal-body">
        <div className="row mb-3">
          <div className="col-4 fw-bold">Name Role</div>
          <div className="col-8">{data.nameRole || data.name}</div>
        </div>
        <div className="row mb-3">
          <div className="col-4 fw-bold">Description</div>
          <div className="col-8">{data.description}</div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ViewRole; 